<template>
    <div
      v-if="prevEntityId != ''"
      class="pb-6 px-6"
      style="position: absolute; bottom: 0; width: 36px;"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn
            data-testid="prev-button"
            elevation="0"
            class="rounded-lg text-none pa-0"
            v-on="on"
            color="accent"
            min-width="36px"
            @click="prevPage()"
          >
            <v-icon size="24">
              mdi-chevron-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('prevPageTooltip') }}</span>
      </v-tooltip>
    </div>
</template>
<script>

export default {
    props: {
        activityPages: {
          type: Array,
          default: () => []
        }
    },
        data(){
        return{
            activityId: this.$route.params.id,
            prevEntityType: '',
            prevEntityId: '',
        }
    },
    async created(){  
        this.loadingData = true
        await this.getPrevFeedItem()
        this.loadingData = false     
    },
    methods:{
        async getPrevFeedItem(){
            const thisRouteName = this.$route.name
            this.prevEntityType = ''
            this.prevEntityId = ''
            let thisEntityType = ''
            let thisEntityId = ''

            if (thisRouteName == 'ViewActivityPage') {
                thisEntityType = 'activity_page'
                thisEntityId = this.$route.params.pageId
            } else if (thisRouteName == 'ViewActivityQuiz') {
                thisEntityType = 'quiz'
                thisEntityId = this.$route.params.quizId
            }else if (thisRouteName == 'ViewActivityScorm') {
                thisEntityType = 'scorm'
                thisEntityId = this.$route.params.scormId
            }else if (thisRouteName == 'ViewActivityChecklist') {
                thisEntityType = 'checklist'
                thisEntityId = this.$route.params.checklistId
            }else if (thisRouteName == 'ViewActivitySurvey') {
                thisEntityType = 'survey'
                thisEntityId = this.$route.params.surveyId
            }
            if (this.activityPages.length > 0) {
                var savePrev = false
                for (let i = this.activityPages.length - 1; i >= 0; i--) {
                    if (this.activityPages[i].attributes.entity_type !== 'section'){
                        if(savePrev != false) {
                            this.prevEntityType = this.activityPages[i].attributes.entity_type
                            this.prevEntityId = this.activityPages[i].attributes.entity_id
                            break
                        }
                        if (this.activityPages[i].attributes.entity_type == thisEntityType && this.activityPages[i].attributes.entity_id == thisEntityId) {
                            savePrev = true
                        }
                    }
                }
            }
            
        },
        prevPage() {
            var entity = ''
            if (this.prevEntityType == 'activity_page') {
                entity = 'page'
            } else if (this.prevEntityType == 'quiz') {
                entity = 'quiz'
            }else if (this.prevEntityType == 'scorm') {
                entity = 'scorm'
            }else if (this.prevEntityType == 'checklist') {
                entity = 'checklist'
            }else if (this.prevEntityType == 'survey') {
                entity = 'survey'
            }
            if (entity) {
                this.$router.push({path: '/activity/' + this.$route.params.id + '/' + entity + '/' + this.prevEntityId})
            }
        },
    },
}
</script>